import React, { FC, useContext } from 'react';

// Components
import { ConfigContext, TextBlockTailwind, TournamentHeader } from '@velinsi/smp-widgets-ui';
import MatchList from '../../MatchList/MatchList';

// Constants
import { ODDS } from '../../../../../../packages/constants/statusFilters';

// Types
import { INormalizedMatchV2, ISubscriberInfo } from '../../../../../../packages/types';
import { INormalizedTournamentMatches } from '../../../types';

interface Props {
  data?: INormalizedTournamentMatches[];
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
  selectedFilter: string;
}

export const TournamentMatches: FC<Props> = ({ data, handleClick, selectedFilter }) => {
  const { dataLabels, dataOddsBettingId = '' } = useContext(ConfigContext);
  const bettingIdValue = dataOddsBettingId && typeof dataOddsBettingId === 'string' ? dataOddsBettingId : dataOddsBettingId?.toString();

  const getFilteredMatches = (matches: INormalizedMatchV2[], selectedFilter: string) => {
    const selectedBookmakers = bettingIdValue?.split(/,\s*/).filter((id) => id);

    if (selectedFilter !== ODDS) {
      return matches;
    }

    if (selectedBookmakers?.length === 0) {
      return matches.filter((match) => match.odds.length > 0);
    }

    return matches.filter((match) => match.odds.some(({ bookmaker }) => bookmaker && selectedBookmakers?.includes(bookmaker?.id)));
  };

  const normalizedData = data?.map(({ tournament, matches }) => ({
    tournament,
    filteredMatches: getFilteredMatches(matches, selectedFilter),
  }));

  const hasEvents = normalizedData?.some(({ filteredMatches }) => filteredMatches.length > 0);

  if (!hasEvents) {
    return <TextBlockTailwind text={dataLabels?.no_games} />;
  }

  return (
    <>
      {normalizedData?.map(
        ({ tournament, filteredMatches }) =>
          filteredMatches.length > 0 && (
            <div key={tournament.id}>
              <TournamentHeader {...tournament} handleClick={handleClick} />
              <MatchList matches={filteredMatches} handleClick={handleClick} />
            </div>
          ),
      )}
    </>
  );
};
